/**
 * Primary marketplace category for every connector the server catalog lists,
 * by normalized key (see `normalizeConnectorKey`). The registry API sends no
 * category, and the local catalog in `data/connectors.ts` covers only a few
 * sources, so without this map every other server connector landed under
 * "Other". Keys mirror `ConnectorType` in magicbi_core
 * (integrations/connectors/enums.py); a test keeps the two in step.
 *
 * Category keys are the ones `CATEGORY_LABELS` names in the registry mapper.
 */
export type ConnectorCategoryType =
  | "ANALYTICS"
  | "APP"
  | "BI"
  | "CRM"
  | "DATABASE"
  | "DATA_WAREHOUSE"
  | "FILES"
  | "PRODUCTIVITY";

export const CONNECTOR_CATEGORY_BY_KEY: Readonly<
  Record<string, ConnectorCategoryType>
> = {
  airtable: "PRODUCTIVITY",
  amplitude: "ANALYTICS",
  asana: "PRODUCTIVITY",
  bigquery: "DATA_WAREHOUSE",
  confluence: "PRODUCTIVITY",
  csv: "FILES",
  databricks: "DATA_WAREHOUSE",
  ga4: "ANALYTICS",
  gong: "APP",
  googlesheets: "FILES",
  greenhouse: "APP",
  hubspot: "CRM",
  intercom: "APP",
  jira: "PRODUCTIVITY",
  linear: "PRODUCTIVITY",
  looker: "BI",
  mailchimp: "APP",
  metabase: "BI",
  mixpanel: "ANALYTICS",
  mysql: "DATABASE",
  netsuite: "APP",
  notion: "PRODUCTIVITY",
  pdf: "FILES",
  postgres: "DATABASE",
  powerbi: "BI",
  qlik: "BI",
  quickbooks: "APP",
  redshift: "DATA_WAREHOUSE",
  salesforce: "CRM",
  shopify: "APP",
  slack: "PRODUCTIVITY",
  snowflake: "DATA_WAREHOUSE",
  sqlserver: "DATABASE",
  stripe: "APP",
  tableau: "BI",
  workday: "APP",
  xlsx: "FILES",
  zendesk: "APP",
};

/**
 * Marketplace tab for each backend `connector_category` value, used for
 * connectors the per-key map above does not list. The per-key map wins
 * because it holds groups the backend enum has no value for (Databases).
 */
export const CONNECTOR_CATEGORY_BY_BACKEND_CATEGORY: Readonly<
  Record<string, ConnectorCategoryType>
> = {
  warehouse: "DATA_WAREHOUSE",
  bi_tool: "BI",
  product_analytics: "ANALYTICS",
  marketing: "ANALYTICS",
  crm: "APP",
  commerce: "APP",
  support: "APP",
  finance: "APP",
  hr: "APP",
  messaging: "APP",
  project_mgmt: "PRODUCTIVITY",
  docs: "PRODUCTIVITY",
  files: "FILES",
  unstructured: "FILES",
};
